import FBIHttp from "./FBIHttp";

export interface defaul {
  content:{
    areas:AreaOutput[],
  }
}

export interface AreaOutput {
  modulo: Number,
  codigo: string,
  nome: string,
  id:string
}

class AreaService {
  private static readonly baseUrl = '/api/bi/Area';

  public static obterListaDeAreasPorModulo = async (modulo?: string | null): Promise<defaul> => FBIHttp.get(`${this.baseUrl}/${modulo}`);
}

export default AreaService;